import { ButtonComponent } from "components";
import { loadingComplete, showLoading } from "utils/loader";
import { net } from "utils/net";

import { useAuth } from "providers/auth";
import { useState } from "react";
import { useDataProvider } from "../../providers";
import { useNavigate, useParams } from "react-router-dom";
import { useDevice } from "hooks";

export function SaveChangesButtonComponent() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, isClean } = useDataProvider();
  const { accessToken } = useAuth();
  const { mutate } = useDevice({ deviceId: id });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  async function handleClick() {
    if (!isClean) return;
    if (!accessToken) return;

    try {
      showLoading("device.save-changes");
      setIsLoading(true);

      const relUrl = `/devices/${id}`;
      const body = {
        name: data.name,
        brand_id: data.brandId,
        warranty: data.warranty?.map((w) => ({
          part_id: w.part.id,
          warranty_period: w.warrantyPeriod,
        })),
      };

      const netInstance = net(accessToken);
      await netInstance.patch(relUrl, body);
      await mutate();

      loadingComplete("device.save-changes", false);

      navigate(-1);
    } catch (err) {
      loadingComplete("device.save-changes", true);
    }
  }

  return (
    <ButtonComponent disabled={!isClean || isLoading} onClick={handleClick}>
      Save Changes
    </ButtonComponent>
  );
}
